import * as React from 'react'
import styled from 'styled-components'
import {
  typoHeading1,
  typoHeading2,
  typoHeading3,
  typoHeading4,
  typoHeading5,
  typoHeadingL,
  typoHeadingXl,
  typoParagraph,
  typoParagraphS,
} from '../../../lib/styles/Typography'

const headlineStyle = {
  xxlarge: typoHeadingXl,
  xlarge: typoHeadingL,
  large: typoHeading2,
  medium: typoHeading3,
  normal: typoHeading4,
  small: typoHeading5,
}

const headlineMaxWidth = {
  xlarge: '46rem',
  large: '46rem',
  medium: '36rem',
  normal: '36rem',
  small: '36rem',
}

export interface TitleWithPrefixProps {
  headlineSize?: 'xxlarge' | 'xlarge' | 'large' | 'medium' | 'normal' | 'small'
  sublineSize?: 'xxlarge' | 'xlarge' | 'large' | 'medium' | 'normal' | 'small'
  headlineType?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  prefix?: string
  textAlign?: 'left' | 'center'
  title: string,
  color?: string
  subline?: string
  descriptionColor?: string
}

const Wrapper = styled.div<{ $align?: 'left' | 'center' }>`
  text-align: ${({ $align }) => $align || 'center'};
`

const Subline = styled.p<{ $size: 'xxlarge' | 'xlarge' | 'large' | 'medium' | 'normal' | 'small', $align?: 'left' | 'center', $descriptionColor?: string }>`
  ${({ $size }) => headlineStyle[$size]}
  text-align: ${({ $align }) => $align || 'center'};
  font-weight: 500;
  color: ${({ $descriptionColor }) => $descriptionColor || 'inherit'};
  max-width: 40rem;
  margin-inline: auto;
`

const Prefix = styled.div<{
  $size?: 'xxlarge' | 'xlarge' | 'large' | 'medium' | 'normal' | 'small'
}>`
  ${({ $size }) => headlineStyle[$size]}
  margin-bottom: ${p => (p.$size === 'medium' ? '0.25rem' : '0.5rem')};
`

const Title = styled.h2<{
  $size: 'xxlarge' | 'xlarge' | 'large' | 'medium' | 'normal' | 'small'
  $align?: 'left' | 'center'
}>`
  ${({ $size }) => headlineStyle[$size]}
  max-width: ${({ $size }) => headlineMaxWidth[$size]};
  margin-inline: ${({ $align }) => ($align === 'left' ? 'none' : 'auto')};
  color: ${({ color }) => color || 'var(--color-black)'};
  padding: 1rem 0;
  font-weight: bold;
`

export const TitleWithPrefix = ({
  prefix,
  title,
  headlineSize = 'xlarge',
  sublineSize = 'normal',
  headlineType = 'h2',
  textAlign = 'center',
  color,
  subline,
  descriptionColor,
}: TitleWithPrefixProps) => {

  return (
    <Wrapper $align={textAlign}>
      <Prefix $size={headlineSize}>{prefix}</Prefix>
      <Title as={headlineType} $size={headlineSize} $align={textAlign} color={color} >
        {title}
      </Title>
      <Subline $size={sublineSize} $align={textAlign} $descriptionColor={descriptionColor}>{subline}</Subline>
    </Wrapper>
  )
}
